import React from 'react';
import { Error, TextInput } from '../../LoginPage/LoginPage.styles';

const FormField = (props) => (
  <div>
    <TextInput
      error={props.error}
      field={props.field}
      type={props.inputType}
      placeholder={props.placeholder}
      value={props.value}
      onChange={(e) => props.setValue(e, props.field)}
      className={props.error[props.field] ? 'error' : ''}
    />

    {props.error[props.field] && <Error>{props.error[props.field]}</Error>}
  </div>
);

export default FormField;
